<script setup>
import { onMounted, ref, computed, inject, watch } from 'vue';
import { __, requestRegistrationFormFields, checkIfOnlyEsim } from '@/utils';
import { Field, ErrorMessage } from 'vee-validate';

const props = defineProps(['name']);

const shippingPrices = ref(
	{
	'regular' : 0,
	'fast': 0
	}
);
const onlyEsim = ref(checkIfOnlyEsim());
const { isExistingAccount } = inject('step2');
const showShipping = ref(isExistingAccount.value);

const fetchFastShippingPrice = async () => {
    try {
        const response = await requestRegistrationFormFields();
		if (response.data.fast_shipping_price !== ''){
			shippingPrices.value.fast = response.data.fast_shipping_price;
		}
		if (response.data.regular_shipping_price !== ''){
			shippingPrices.value.regular = response.data.regular_shipping_price;
		}
    } catch (error) {
        console.error('Error fetching plans:', error);
    }
};

onMounted(() => {
	fetchFastShippingPrice();
});
 
const radioInputs = computed(() => [
	{ id: 'home', text: __('Home delivery (') + shippingPrices.value.fast + ' ' + __('NIS) - up to 3 business days'), value: 'fast' },
    { id: 'post', text: __('Israel Post (') + shippingPrices.value.regular + ' ' +  __('NIS ) - up to 7 business days'), value: 'regular' },
]);

watch(isExistingAccount, () => {
    showShipping.value = isExistingAccount.value;
});
</script>
<template>
	<div class="fields" v-if="!onlyEsim">
		<div class="fields__head">
			<h6>
				{{ __('Shipping method') }} *
			</h6>
		</div><!-- /.fields__head -->

		<div class="fields__body">
			<template v-for="input in radioInputs" :key="input.id">
				<div class="radio-button">
					<Field type="radio" :name="`${name}ShippingMethod`" :value="input.value"
						:id="input.id" />

					<label :for="input.id">
						{{ input.text }}
					</label>
				</div><!-- /.radio -->
			</template>

			<ErrorMessage :name="`${name}ShippingMethod`" as="span" class="error error--shipping" />
		</div><!-- /.fields__body -->
	</div><!-- /.fields -->
</template>
